var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsContentLetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19C19 19.552 18.552 20 18 20H6C5.449 20 5 19.552 5 19V5C5 4.46545 5.43762 4 6 4H18C18.552 4 19 4.449 19 5V19ZM6 2C4.25891 2 3 3.08423 3 5V19C3 20.654 4.346 22 6 22H18C19.654 22 21 20.654 21 19V5C21 3.346 19.654 2 18 2C18 2 8 2 6 2Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2861 9H7.71411C7.16211 9 6.71411 8.552 6.71411 8C6.71411 7.448 7.16211 7 7.71411 7H16.2861C16.8391 7 17.2861 7.448 17.2861 8C17.2861 8.552 16.8391 9 16.2861 9Z",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2861 13H7.71411C7.16211 13 6.71411 12.553 6.71411 12C6.71411 11.447 7.16211 11 7.71411 11H16.2861C16.8391 11 17.2861 11.447 17.2861 12C17.2861 12.553 16.8391 13 16.2861 13Z",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2861 17H7.71411C7.16211 17 6.71411 16.553 6.71411 16C6.71411 15.447 7.16211 15 7.71411 15H16.2861C16.8391 15 17.2861 15.447 17.2861 16C17.2861 16.553 16.8391 17 16.2861 17Z",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsContentLetter);
export default __webpack_public_path__ + "static/media/icons-content-letter.912ef71db2256604538acab352e79ca4.svg";
export { ForwardRef as ReactComponent };